import React, { forwardRef, useState } from "react";
import Css from "./About.module.css";
import { Link } from "react-router-dom";
import Picture from "../Picture/black.jpeg";
import { FaFacebookF, FaGithub, FaLinkedinIn } from "react-icons/fa";
const pdf =
  "https://portfolio97by-mohamed-adel.netlify.app/MohamedAdel-FrontEnd.pdf";
const About = forwardRef(({ waring }, about) => {
  const [setBar, getBar] = useState(false);
  const scrolly = () => {
    if (window.scrollY >= 500) {
      getBar(true);
    } else {
      getBar(false);
    }
  };
  const downloadPdf = (url) => {
    const fileName = url.split("/").pop();
    const aTag = document.createElement("a");
    aTag.href = url;
    aTag.setAttribute("download", fileName);
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  };
  window.addEventListener("scroll", scrolly);
  return (
    <div>
      <div id="about" ref={about} className={Css.parent}>
        <div className={Css.about}>
          <h1>
            About <span>Me</span>
          </h1>
        </div>
        <div className={Css.container}>
          <div className={Css.card}>
            <div className={Css.img}>
              <img src={Picture} alt="" />
            </div>
            <div className={Css.text}>
              <h1>Mohamed-Adel</h1>
              <p>howare7amo99@gmail.com</p>
              <div className={Css.icons}>
                <Link to="https://www.facebook.com/profile.php?id=100012706116123">
                  <FaFacebookF />
                </Link>
                <Link to="https://www.linkedin.com/in/mohamed-adel-226611286/">
                  <FaLinkedinIn />
                </Link>
                <Link to="https://github.com/Mohamed-Adel0">
                  <FaGithub />
                </Link>
              </div>
              <Link onClick={() => {downloadPdf(pdf);}}>Download CV</Link>
            </div>
          </div>
          <div className={Css.card}>
            <div className={Css.textSkills}>
              <h1>
                <span>My</span> Skills
              </h1>
            </div>
            <div className={Css.skills}>
              <div className={Css.skill}>
                <div className={Css.skillName}>
                  <h4>HTML</h4>
                </div>
                <div
                  className={`${`${Css.skillbar} ${
                    setBar ? Css.animation : ""
                  }`} ${setBar ? Css.animation : ""}`}
                >
                  <div
                    className={Css.skillper}
                    per="90%"
                    style={{ maxWidth: "90%" }}
                  />
                </div>
              </div>
              <div className={Css.skill}>
                <div className={Css.skillName}>
                  <h4>CSS & SASS</h4>
                </div>
                <div
                  className={`${Css.skillbar} ${setBar ? Css.animation : ""}`}
                >
                  <div
                    className={Css.skillper}
                    per="80%"
                    style={{ maxWidth: "80%" }}
                  />
                </div>
              </div>
              <div className={Css.skill}>
                <div className={Css.skillName}>
                  <h4>Javascript</h4>
                </div>
                <div
                  className={`${Css.skillbar} ${setBar ? Css.animation : ""}`}
                >
                  <div
                    className={Css.skillper}
                    per="70%"
                    style={{ maxWidth: "70%" }}
                  />
                </div>
              </div>
              <div className={Css.skill}>
                <div className={Css.skillName}>
                  <h4>Bootstrap</h4>
                </div>
                <div
                  className={`${Css.skillbar} ${setBar ? Css.animation : ""}`}
                >
                  <div
                    className={Css.skillper}
                    per="85%"
                    style={{ maxWidth: "85%" }}
                  />
                </div>
              </div>
              <div className={Css.skill}>
                <div className={Css.skillName}>
                  <h4>react</h4>
                </div>
                <div
                  className={`${Css.skillbar} ${setBar ? Css.animation : ""}`}
                >
                  <div
                    className={Css.skillper}
                    per="70%"
                    style={{ maxWidth: "70%" }}
                  />
                </div>
              </div>
            </div>
            <div className={Css.paragraph}>
              <p>
                1-it's my skills, and i'm working on myself to learn more
                experience..
              </p>
              <p>
                2-Created pixel-perfect website layouts from design mockups
                using <span>HTML</span>, <span>CSS</span>,{" "}
                <span>JavaScript</span>..
              </p>
              <p>
                3-Developed and maintained <span>front-end code</span> for
                complex web applications using <span>React.js</span> and{" "}
                <span>Redux</span>..
              </p>
              <p>
                4-Contributed to the development of a customer dashboard,
                providing real-time analytics and data visualization..
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default About;
